export const GET_ASSET_DATA = '@@asset/getAssetData';
